import styled from '@emotion/styled'
import { ButtonBase } from '@mui/material'
import { fontSize, size } from '@styles/theme'

const SectionDivision = styled.div`
  height: ${size(2)};
  width: 100%;
`

const SectionHeader = styled.h2`
  text-align: center;
  width: 100%;
`

const SectionWrapper = styled.div`
  padding: ${size(2)} 0 ${size(1)} 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`

const ActionButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${size(1)};
`


const ActionButton = styled(ButtonBase)`
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: #141414;
  border-radius: 12px;
  flex-shrink: 0;
  font-weight: 500;
  font-size: ${fontSize('md')};
  padding: ${size(1)};
  width: ${size(15)};
  height: ${size(8)};
  // margin: ${size(0.5)};
  border: 0.5px solid rgba(255,255,255, 0.15);
`

export { SectionWrapper, SectionHeader, SectionDivision, ActionButtonContainer, ActionButton }